import classnames from 'classnames/bind';

import { IconType } from 'types/icon';
import { WidgetType } from 'types/dashboard_widget';

import { Heading } from 'components/Heading/Heading';
import { Icon } from 'components/Icon/IconDeprecated';
import { Text } from 'components/Text/Text';

import styles from './Header.module.scss';

const c = classnames.bind(styles);

type WidgetModalHeaderProps = {
  type: WidgetType;
};

const WIDGET_MODAL_HEADER_MAP: Record<
  WidgetType,
  { icon: IconType; description: string; label: string }
> = {
  data: {
    icon: 'metrics',
    description: 'Analyze data output from workflows.',
    label: 'Data',
  },
  iframe: {
    icon: 'puzzle',
    description: 'Embed content from a web URL.',
    label: 'Iframe',
  },
  stream: {
    icon: 'stream',
    description: 'Display a video player for a selected stream.',
    label: 'Stream',
  },
  multistream: {
    icon: 'stream',
    description: 'Display video players for streams matching filter criteria.',
    label: 'Multistream',
  },
  files: {
    icon: 'file',
    description: 'List all files based on filter criteria.',
    label: 'Files',
  },
  'files-search': {
    icon: 'search',
    description:
      'List files based on classification. Identify objects, events, scenes, watchlist items and text within clips and images.',
    label: 'Files search',
  },
  'trackable-status': {
    icon: 'clock',
    description: 'See the last match time for each watchlist item in a list.',
    label: 'Watchlist status',
  },
  markdown: {
    icon: 'file',
    description: 'Display formatted markdown content.',
    label: 'Markdown',
  },
  cameras: {
    icon: 'camera',
    description: 'Display cameras with filters and video previews.',
    label: 'Cameras',
  },
  'system-state': {
    icon: 'metrics',
    description:
      'Display system status counts for cameras, streams, deployments, and gateways.',
    label: 'System State',
  },
  'system-events': {
    icon: 'clock',
    description: 'Display recent system events log.',
    label: 'System Events',
  },
};

export function WidgetFormHeader({ type }: WidgetModalHeaderProps) {
  const { icon, description, label } = WIDGET_MODAL_HEADER_MAP[type];

  return (
    <div className={c('type')}>
      <Icon className={c('icon')} name={icon} />
      <Heading className={c('heading')} level="3">
        {label}
      </Heading>
      <Text className={c('info')} align="start" type="paragraph">
        {description}
      </Text>
    </div>
  );
}
